import summitImg from '@/assets/card/summitImg';

import Card from './Card';

const SummitCard = ({ cardId, width, height }) => {
	return (
		<Card
			cardId={cardId}
			width={width}
			height={height}
			cardImageArray={summitImg}
		/>
	);
};

export default SummitCard;
